import axios from "axios";

const collectionName = process.env.REACT_APP_MONGO_COLLECTION_NAME;
const dbName = process.env.REACT_APP_MONGO_DB_NAME;
export class MONGODBApisL {
  static getObservationByID = async (Id) => {
    if (!Id) {
      console.error("ID is required");
      return { data: null, success: false, error: "Missing ID" };
    }

    const baseURL = process.env.REACT_APP_MONGO_API_BASEURL;
    if (!baseURL) {
      console.error("Missing Mongo API base URL in environment variables");
      return { data: null, success: false, error: "Missing API base URL" };
    }

    try {
      const payload = {
        collectionName,
        dbName,
        id: Id,
      };

      const response = await axios.post(
        `${baseURL}/getObservationById`,
        payload,
      );
      return { data: response.data, success: true };
    } catch (error) {
      console.error("Error fetching observation by ID:", error);
      return {
        data: error?.response?.data || error.message,
        success: false,
      };
    }
  };

  static getDataByAssetId = async (assetId) => {
    if (!assetId) {
      console.error("assetId is required");
      return { data: null, success: false, error: "Missing assetId" };
    }

    const baseURL = process.env.REACT_APP_MONGO_API_BASEURL;
    if (!baseURL) {
      console.error("Missing Mongo API base URL in environment variables");
      return { data: null, success: false, error: "Missing API base URL" };
    }

    try {
      const payload = {
        collectionName,
        dbName,
        assetId: assetId,
      };

      const response = await axios.post(`${baseURL}/getDataByAssetId`, payload);
      return { data: response.data, success: true };
    } catch (error) {
      console.error("Error fetching observation by ID:", error);
      return {
        data: error?.response?.data || error.message,
        success: false,
      };
    }
  };

  static getObservationsWithinBounds = async (bounds, asset) => {
    const assetId = asset.Name;

    const lngMin = bounds._southWest.lng;
    const lngMax = bounds._northEast.lng;
    const latMin = bounds._southWest.lat;
    const latMax = bounds._northEast.lat;

    if (!bounds) {
      console.error("bounds is required");
      return { data: null, success: false, error: "Missing bounds" };
    }

    const baseURL = process.env.REACT_APP_MONGO_API_BASEURL;
    if (!baseURL) {
      console.error("Missing Mongo API base URL in environment variables");
      return { data: null, success: false, error: "Missing API base URL" };
    }

    try {
      const payload = {
        collectionName,
        dbName,
        latMin,
        latMax,
        lngMin,
        lngMax,
        filters: {
          assetId,
        },
        excludeFilters: { createdBy: "uploaded" },
      };

      const response = await axios.post(
        `${baseURL}/getDataWithinBounds`,
        payload,
      );
      return { data: response.data, success: true };
    } catch (error) {
      console.error("Error fetching observation by ID:", error);
      return {
        data: error?.response?.data || error.message,
        success: false,
      };
    }
  };

  static getObservationsWithinBoundsTimelineOpenLayers = async (
    bounds,
    timelineRef,
  ) => {
    const [lngMin, latMin, lngMax, latMax] = bounds;

    if (!bounds) {
      console.error("bounds is required");
      return { data: null, success: false, error: "Missing bounds" };
    }

    const baseURL = process.env.REACT_APP_MONGO_API_BASEURL;
    if (!baseURL) {
      console.error("Missing Mongo API base URL in environment variables");
      return { data: null, success: false, error: "Missing API base URL" };
    }

    try {
      const payload = {
        collectionName,
        dbName,
        latMin,
        latMax,
        lngMin,
        lngMax,
        filters: {
          timelineRef,
        },
      };

      const response = await axios.post(
        `${baseURL}/getDataWithinBounds`,
        payload,
      );
      return { data: response.data, success: true };
    } catch (error) {
      console.error("Error fetching observation by ID:", error);
      return {
        data: error?.response?.data || error.message,
        success: false,
      };
    }
  };

  static getDataByFilter = async (filters, containsFilter = {}) => {
    const baseURL = process.env.REACT_APP_MONGO_API_BASEURL;
    if (!baseURL) {
      console.error("Missing Mongo API base URL in environment variables");
      return { data: null, success: false, error: "Missing API base URL" };
    }

    try {
      const payload = {
        collectionName,
        dbName,
        filters,
        containsFilter,
      };

      const response = await axios.post(`${baseURL}/getDataByFilters`, payload);
      return { data: response.data, success: true };
    } catch (error) {
      console.error("Error fetching observation by ID:", error);
      return {
        data: error?.response?.data || error.message,
        success: false,
      };
    }
  };
}

export class MongoAnnotationManager {
  static addAnnotations = async (dataToPush) => {
    if (!dataToPush) {
      console.error("dataToPush is required");
    }

    const baseURL = process.env.REACT_APP_MONGO_API_BASEURL;
    if (!baseURL) {
      console.error("Missing Mongo API base URL in environment variables");
    }

    try {
      const payload = {
        collectionName,
        dbName,
        data: dataToPush,
      };
      const response = await axios.post(`${baseURL}/addEntry`, payload);
    } catch (error) {
      console.error("Error adding addAnnotations:", error);
    }
  };

  static deleteAnnotations = async (id) => {
    if (!id) {
      console.error("ID is required");
      return false;
    }

    const baseURL = process.env.REACT_APP_MONGO_API_BASEURL;
    if (!baseURL) {
      console.error("Missing Mongo API base URL in environment variables");
      return false;
    }

    try {
      const response = await axios.delete(`${baseURL}/deleteEntry`, {
        data: {
          collectionName,
          dbName,
          id: id,
        },
      });
      return true;
    } catch (error) {
      console.error("Error /deleteEntry observation by ID:", error);
      return false;
    }
  };

  static editAnnotations = async (key, fieldsToUpdate) => {
    if (!key || !fieldsToUpdate) {
      console.error("dataToPush is required");
    }

    const baseURL = process.env.REACT_APP_MONGO_API_BASEURL;
    if (!baseURL) {
      console.error("Missing Mongo API base URL in environment variables");
    }

    try {
      const payload = {
        collectionName,
        dbName,
        query: key,
        data: fieldsToUpdate,
      };

      const response = await axios.post(`${baseURL}/editEntry`, payload);
    } catch (error) {
      console.error("Error editEntry :", error);
    }
  };

  static editShape = async (key, geo) => {
    if (!key || !geo) {
      console.error("dataToPush is required");
    }

    const baseURL = process.env.REACT_APP_MONGO_API_BASEURL;
    // const baseURL = "http://192.168.0.149:8001/api/v1/mongo";
    if (!baseURL) {
      console.error("Missing Mongo API base URL in environment variables");
    }
    try {
      const payload = {
        collectionName,
        dbName,
        query: key,
        geo,
      };

      const response = await axios.post(`${baseURL}/editShape`, payload);
    } catch (error) {
      console.error("Error editEntry :", error);
    }
  };
}

// export class CommentManager {
//   static addComments = async (dataToPush) => {
//     try {
//       const params = {
//         TableName: tableName,
//         Item: marshall(dataToPush), // Convert JS object to DynamoDB format
//       };

//       const command = new PutItemCommand(params);
//       await docClient.send(command);
//       return "Commented Sucessfully";
//     } catch (error) {
//       console.error("Error pushing data to the table:", err);
//       return false;
//     }
//     // else {
//     //   //
//     //   return "Annotated Sucessfully";
//     // }
//   };

//   static getCommentsByMarkerID = async (markerID) => {
//     const params = {
//       TableName: tableName,
//       FilterExpression: "markerID = :markerID",
//       ExpressionAttributeValues: marshall({ ":markerID": markerID }),
//     };

//     try {
//       const command = new ScanCommand(params);
//       const results = await dbClient.send(command);
//       const unMarshalled = results.Items.map((item) => unmarshall(item));
//       const sortedItems = unMarshalled.sort((a, b) => {
//         return b.timestamp - a.timestamp;
//       });

//       return sortedItems;
//     } catch (error) {
//       console.error("Error querying table:", err);
//     }
//   };

//   static deleteComment = (id, timestamp) => {
//     const params = {
//       TableName: tableName,
//       Key: marshall({ id: id, timestamp: timestamp }),
//     };

//     try {
//       const command = new DeleteItemCommand(params);
//       const response = docClient.send(command);
//       // console.log("✅ Item deleted successfully:", response);
//       return true;
//     } catch (error) {
//       console.error("Error deleting item:", err);
//       return false;
//     }
//     // else {
//     //   //
//     //   return "Item deleted successfully";
//     // }
//   };

//   static updateCommentById = async (key, newComment) => {
//     const params = {
//       TableName: tableName,
//       Key: marshall(key),
//       UpdateExpression: "SET #comment = :newComment", // Update the 'comment' attribute
//       ExpressionAttributeValues: marshall({ ":newComment": newComment }),
//       ExpressionAttributeNames: {
//         "#comment": "comment", // Define the alias for 'comment'
//       },
//       ReturnValues: "ALL_NEW", // Return the updated item
//     };

//     try {
//       const command = new UpdateItemCommand(params);
//       const response = await docClient.send(command);

//       const updatedItem = unmarshall(response.Attributes);
//       return updatedItem; // Return updated item
//     } catch (error) {
//       console.error("Error updating item:", error);
//       return null;
//     }

//     //     return new Promise((resolve, reject) => {
//     //       docClient.update(params, (err, data) => {
//     //         if (err) {
//     //           console.error("Error updating item:", err);
//     //           reject(err);
//     //         } else {
//     //           resolve(data.Attributes); // Return the updated item's attributes
//     //         }
//     //       });
//     //     });
//     //   };
//     // }

//     // export const getPolyAnnotation = (assetId, filter_type) => {
//     //   const filterExpression = "filter_type = :filter_type AND assetId = :assetId";
//     //   const expressionAttributeValues = {
//     //     ":assetId": assetId,
//     //     ":filter_type": filter_type,
//     //   };

//     //   const params = {
//     //     TableName: tableName,
//     //     FilterExpression: filterExpression,
//     //     ExpressionAttributeValues: expressionAttributeValues,
//     //   };

//     //   return new Promise((resolve, reject) => {
//     //     docClient.scan(params, (err, data) => {
//     //       if (err) {
//     //         console.error("Error querying table:", err);
//     //         reject(err);
//     //       } else {
//     //         //
//     //         resolve(data.Items);
//     //       }
//     // });
//   };
// }
